// Read-only stats strip under the page header — derived live from the feed
// atoms: live/upcoming/archived market counts plus the archive's distinct
// sports and leagues. Case-insensitive sport counting (import batches mix
// "Soccer" and "soccer").

import { useAtomValue } from 'jotai';
import {
  archiveAtom,
  liveEventGroupsAtom,
  upcomingEventGroupsAtom,
} from '../feed';

const Chip = ({ children }: { children: React.ReactNode }) => (
  <span className="rounded-full bg-content1 px-3 py-1 text-xs tabular-nums">
    {children}
  </span>
);

export function StatsStrip() {
  const live = useAtomValue(liveEventGroupsAtom);
  const upcoming = useAtomValue(upcomingEventGroupsAtom);
  const archive = useAtomValue(archiveAtom);

  const liveMarkets = live.reduce((n, g) => n + g.markets.length, 0);
  const upcomingMarkets = upcoming.reduce((n, g) => n + g.markets.length, 0);
  const sports = new Set(
    archive.map((e) => e.event.sport.toLowerCase()).filter(Boolean),
  ).size;
  const leagues = new Set(archive.map((e) => e.event.league).filter(Boolean))
    .size;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Chip>
        <span className="font-semibold">{liveMarkets}</span> live
      </Chip>
      <Chip>
        <span className="font-semibold">{upcomingMarkets}</span> upcoming
      </Chip>
      <Chip>
        <span className="font-semibold">{archive.length}</span> archived
      </Chip>
      {sports > 0 && (
        <Chip>
          <span className="font-semibold">{sports}</span> sports
        </Chip>
      )}
      {leagues > 0 && (
        <Chip>
          <span className="font-semibold">{leagues}</span> leagues
        </Chip>
      )}
    </div>
  );
}
